import { render, staticRenderFns } from "./killDaily.vue?vue&type=template&id=a50b6e70&"
import script from "./killDaily.vue?vue&type=script&lang=js&"
export * from "./killDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports